import { FC, useEffect, useState } from 'react';
import { Modal, Form, Input, Radio, Alert } from 'antd';
import { ChapterTypes } from '../../../../../../lib/model/Book';

interface Props {
	open: boolean;
	onCancel: () => void;
	onCreate: (title: string, type: ChapterTypes) => void;
}

export const CreateChapterModal: FC<Props> = ({ open, onCancel, onCreate }) => {
	const [title, setTitle] = useState('');
	const [type, setType] = useState<ChapterTypes>(ChapterTypes.CHAPTER);
	const [showError, setShowError] = useState(false);

	const isChapter = type === ChapterTypes.CHAPTER;

	useEffect(() => {
		if (open) {
			setTitle('');
			setType(ChapterTypes.CHAPTER);
			setShowError(false);
		}
	}, [open]);

	const handleCreate = () => {
		// Valida se o título está em branco APENAS quando for Capítulo Standard
		if (isChapter && !title.trim()) {
			setShowError(true);
			return;
		}

		setShowError(false);
		onCreate(title.trim(), type);
	};

	return (
		<Modal
			open={open}
			title='Novo conteúdo'
			okText='Criar'
			cancelText='Cancelar'
			onOk={handleCreate}
			onCancel={onCancel}
			destroyOnClose
		>
			<Form layout='vertical' style={{ marginTop: '16px' }}>
				{/* Exibe o alerta no topo do modal quando tentar enviar o capítulo sem título */}
				{showError && (
					<Alert
						message='O campo Título é obrigatório para capítulos.'
						type='error'
						showIcon
						style={{ marginBottom: '16px' }}
					/>
				)}

				<Form.Item
					label='Título'
					required={isChapter}
					validateStatus={showError ? 'error' : ''}
					help={showError ? 'Por favor, informe o título.' : undefined}
				>
					<Input
						value={title}
						onChange={(e) => {
							setTitle(e.target.value);
							if (showError && e.target.value.trim()) {
								setShowError(false);
							}
						}}
						status={showError ? 'error' : ''}
						placeholder={isChapter ? 'Informe o título' : 'Opcional para pré/pós-textual'}
					/>
				</Form.Item>

				<Form.Item label='Tipo' required>
					<Radio.Group
						value={type}
						onChange={(e) => {
							setType(e.target.value);
							setShowError(false); // Limpa a mensagem de erro ao alterar o tipo
						}}
					>
						<Radio value={ChapterTypes.PRE_TEXTUAL}>Pré-textual</Radio>
						<Radio value={ChapterTypes.CHAPTER}>Capítulo</Radio>
						<Radio value={ChapterTypes.POS_TEXTUAL}>Pós-textual</Radio>
					</Radio.Group>
				</Form.Item>
			</Form>
		</Modal>
	);
};
// import { FC, useEffect, useState } from 'react';
// import { Modal, Form, Input, Radio } from 'antd';
// import { ChapterTypes } from '../../../../../../lib/model/Book';

// interface Props {
// 	open: boolean;
// 	onCancel: () => void;
// 	onCreate: (title: string, type: ChapterTypes) => void;
// }

// export const CreateChapterModal: FC<Props> = ({ open, onCancel, onCreate }) => {
// 	const [title, setTitle] = useState('');
// 	const [type, setType] = useState<ChapterTypes>(ChapterTypes.CHAPTER);

// 	useEffect(() => {
// 		if (open) {
// 			setTitle('');
// 			setType(ChapterTypes.CHAPTER);
// 		}
// 	}, [open]);

// 	const handleCreate = () => {
// 		if (!title.trim()) {
// 			return;
// 		}

// 		onCreate(title.trim(), type);
// 	};

// 	return (
// 		<Modal
// 			open={open}
// 			title='Novo conteúdo'
// 			okText='Criar'
// 			cancelText='Cancelar'
// 			onOk={handleCreate}
// 			onCancel={onCancel}
// 			destroyOnClose
// 		>
// 			<Form layout='vertical'>
// 				<Form.Item label='Título' required>
// 					<Input
// 						value={title}
// 						onChange={(e) => setTitle(e.target.value)}
// 						placeholder='Informe o título'
// 					/>
// 				</Form.Item>

// 				<Form.Item label='Tipo' required>
// 					<Radio.Group value={type} onChange={(e) => setType(e.target.value)}>
// 						<Radio value={ChapterTypes.PRE_TEXTUAL}>Pré-textual</Radio>

// 						<Radio value={ChapterTypes.CHAPTER}>Capítulo</Radio>

// 						<Radio value={ChapterTypes.POS_TEXTUAL}>Pós-textual</Radio>
// 					</Radio.Group>
// 				</Form.Item>
// 			</Form>
// 		</Modal>
// 	);
// };
